import { useMemo } from 'react';
import { GuestSummaryAnalyticsResultQuery } from '@mews-commander/guest-profile';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { localizeCurrencyValue } from '@mews-commander/utils';
import { useAnalytics } from '../queries';

const transformData = (data: GuestSummaryAnalyticsResultQuery, currency: string) => ({
    lastStayDate: data.guestSummaryById.analytics.lastStayDate,
    totalAmountSpent:
        data?.guestSummaryById.analytics.totalAmountSpent != null
            ? localizeCurrencyValue({
                  currency,
                  value: data?.guestSummaryById.analytics.totalAmountSpent.netAmount,
              })
            : null,
    totalNightsSpent: data.guestSummaryById.analytics.totalNightsSpent,
    totalStays: data.guestSummaryById.analytics.totalStays,
});

export const useGuestValue = (guestId: string, currency?: string) => {
    const { defaultCurrencyCode } = useCurrentEnterprise();
    const { data, ...props } = useAnalytics({ guestId, currency: currency || defaultCurrencyCode });

    const transformedData = useMemo(
        () => (data ? transformData(data, currency || defaultCurrencyCode) : null),
        [data, currency, defaultCurrencyCode]
    );

    return {
        ...props,
        data: transformedData,
    };
};
